import { Component, OnInit, ViewChild } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
import { DisplayService } from '../../services/display/display.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { HelpService } from '../../services/help/help.service';
import { NoteService } from '../../services/note/note.service';

@Component({
	selector: 'pcm-page-smart-contracts',
	templateUrl: './page-smart-contracts.component.html',
	styleUrls: ['./page-smart-contracts.component.scss']
})
export class PageSmartContractsComponent implements OnInit {

	@ViewChild('modalForm') modalForm;

	title = 'Interim Contract Changes';
	dataObj = this.configService.smartContractDataObj;
	scDataObj;
	selectedRow;
	actions = [];
	columnsConfig = [];
	showExportModal = false;
	allowDelete = false;

	jrSteps = [];
	jrStepIDs = [];

	constructor(
		private commsService: CommsService,
		public configService: ConfigService,
		private dataService: DataService,
		private purchaseOrderService: PurchaseOrderService,
		private displayService: DisplayService,
		public helpService: HelpService,
		public smartContractService: SmartContractService,
		private timesheetService: TimesheetService,
		private noteService: NoteService
	) {
		this.helpService.contracts.forEach(step => {
			this.jrSteps.push(step);
			this.jrStepIDs.push(step.id);
		});
	}

	ngOnInit() {
		this.actions = this.configService.getActions(this.dataObj);
		if (this.actions.length === 0) {
			this.actions.push(this.configService.getExportAction());
		}
		this.columnsConfig = this.configService.getTableFields(this.smartContractService.dataObj, false);
		this.displayService.clearLoading();
		this.timesheetService.loadQuantityTypes();
		this.smartContractService.selectDefaultTab(this.smartContractService.tabsData.listTabs);
	}

	allowAction = () => {
		return this.dataService.selectedTableRows[0] !== undefined;
	}

	takeAction(event) {
		console.log('TAKE ACTION', event);
		this.showExportModal = true;
	}

	tableClick(event) {
		this.selectedRow = [event.row];
		const scType = event.row[this.configService.smartContractTypeProp];
		const scProps = this.smartContractService.getSmartContractProps(scType);
		this.scDataObj = scProps.dataObj;
		event['action'] = this.configService.getAction(scProps.prop);
		if (scProps.prop === 'hoursrestriction') {
			this.allowDelete = true;
		} else {
			this.allowDelete = false;
		}
		this.modalForm.showModal(event['action'], this.scDataObj, this.selectedRow);
	}

	modalSubmit(event) {
		console.log('MODAL SUBMIT', event);
		this.smartContractService.updateSmartContract(event.data, event.prop, this);
		const self = this;
		const delay = setTimeout(function () {
			self.modalForm.formCancel();
		}, 1000);
	}

	modalApprove(event) {
		console.log('MODAL APPROVE', event);
		this.smartContractService.approveSmartContract(event.data, event.prop, this);
		const self = this;
		const delay = setTimeout(function () {
			self.modalForm.formCancel();
		}, 1000);
	}

	modalDelete(event) {
		console.log('MODAL DELETE', event);
		this.smartContractService.deleteSmartContract(event.data, event.prop, this);
		const self = this;
		const delay = setTimeout(function () {
			self.modalForm.formCancel();
		}, 1000);
	}

	successCall() {
		this.dataService.clearSelectedTableRows();
		this.smartContractService.selectDefaultTab(this.smartContractService.tabsData.listTabs);
	}

	errorCall(err) {
		this.noteService.displayError('Failed to process the selected smart contracts');
		console.log('BULK SMART CONTRACTS ERROR');
	}

	closeExportModal() {
		this.showExportModal = false;
	}

	exportToCSV(event) {
		this.commsService.exportToCSV(event.data, this.configService.getTableFields(this.dataObj, false), this.dataService.selectedTableRows);
		const self = this;
		const delay = setTimeout(function () {
			self.closeExportModal();
		}, 1000);
	}
}
